// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pvWMA","option":"styles_option__3foIo","selected":"styles_selected__31rCZ"};